// store/index.js
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

// Función para cargar el estado del sitio desde localStorage
function loadSiteType() {
  const type = localStorage.getItem('site_type');

  // Valor por defecto si no hay valor en localStorage
  //puede ser divas o chads
  return type ? type : 'divas'; 
}

// Function to load chat URL from localStorage (if needed in future)
function loadChatUrl() {
  return localStorage.getItem('chat_url') || null;
}

export default new Vuex.Store({
  state: {
    general: {
      site_type: loadSiteType()  // Cargar el valor desde localStorage
    },
    chat_url: loadChatUrl() // Cargar el valor desde localStorage si es necesario
  },
  mutations: {
    setSiteType(state, newType) {
      state.general.site_type = newType;
      localStorage.setItem('site_type', newType); // Guardar el nuevo valor en localStorage
    },
    setChatUrl(state, newUrl) {
      state.chat_url = newUrl;
      localStorage.setItem('chat_url', newUrl); // Guardar el nuevo valor en localStorage
    }
  },
  actions: {
    updateSiteType({ commit }, newType) {
      commit('setSiteType', newType);
    },
    updateChatUrl({ commit }, newUrl) {
      commit('setChatUrl', newUrl);
    }
  }
});
